/* eslint-disable consistent-return */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Scrollbars } from 'react-custom-scrollbars';
import { Icons } from '@techsoftware/happay-widgets';
import ContainerIcons from './containerIcons';
import history from '../../utils/history';
import { RouteMap } from '../../constants/routeConfigMap';
import Animation from '../animation';
import CookieLib from '../../helpers/cookieLib';
import * as ExpenseAction from '../../actions/expenseAction';
function LeftContainerList(props) {
  const [state, setState] = useState({
    open: false,
    showList: 1,
    showListItem: [],
  });

  // const _getInitState = userInfo => {
  // const path = history.location.pathname;
  // if (
  //   path &&
  //   RouteMap &&
  //   RouteMap[path] &&
  //   (userInfo.has_role || RouteMap[path].forUser)
  // ) {
  //   if(!state.open){ // not to remmove this check
  //     setState({ ...state, ...RouteMap[path]});
  //   }
  // }
  // else {
  // const cid = CookieLib.getCookieByKey('cid');
  // const token = CookieLib.getCookieByKey('token');
  // if (cid && token) {
  //   history.push('/dashboard');
  // }
  // setState({ ...state, open: false, showList: 1, showListItem: [-1] });
  // }
  // };

  // useEffect(() => {
  //   if (props.userinfo) {
  //     _getInitState(props.userinfo);
  //   }
  // }, [props.userinfo]);

  useEffect(() => {
    setActiveTab();
  }, [props.historyChange]);

  const setActiveTab = () => {
    const path = history.location.pathname;
    let tempData = null;
    if (RouteMap[path]) {
      tempData = { ...RouteMap[path] };
    }else if(!path.includes('detail') && !path.includes('edit')){ // this check is to prevent running below block for edit and detailed pages .
      if (path.includes('invoice')) {
        history.push('/invoice/myinvoice?tab=Saved&Count');
        tempData = { ...RouteMap['/invoice/myinvoice'] };
      } else if (path.includes('vendor')) {
        history.push('/vendor/myvendor?tab=Saved&Count');
        tempData = { ...RouteMap['/vendor/myvendor'] };
      } else {
        history.push('/dashboard');
        tempData = { ...RouteMap['/dashboard'] };
      }
    }
    setState({ ...state, ...tempData });
  };
  const _onListClick = (value, isSubListItem) => {
    // if (!props.isDashboardView) {
    //   return false;
    // }
    let { showList, showListItem, open } = state;
    if (value.id === showList && !isSubListItem) {
      // setState({
      //   ...state,
      //   open: !state.open,
      // });
      return false;
    } else {
      // if (
      //   value &&
      //   value.subSegment &&
      //   value.subSegment.length &&
      //   !isSubListItem
      // ) {
      //   let itemIndex = showListItem.indexOf(value.id);
      //   if(itemIndex === -1){
      //     if(state.open){
      //       showListItem.push(value.id);
      //     }else{
      //       showListItem = []
      //       showListItem.push(value.id);
      //     }
      //   }else if(open && !value?.children?.includes(showList)){
      //     showListItem.splice(itemIndex,1);
      //   }
      //   // showList = value.id;
      //   // showListItem = value.subSegment[0].id;
      // } else if (isSubListItem) {
      //   showList = value.id;
      //   if(showListItem.length > 0){
      //     showListItem = [];
      //     if(value.parentId){
      //       showListItem.push(value.parentId);
      //     }
      //   }
      //   // showListItem = value.id;
      // } else if (!isSubListItem) {
      //   showList = value.id;
      //   showListItem = [-1];
      // }
      // setState({
      //   ...state,
      //   showList:showList,
      //   open: true,
      //   showListItem:[...showListItem],
      // });
      if (
        value &&
        value.linkTo !== history.location.pathname &&
        !value?.subSegment
      ) {
        props.clearExpenseFilterQuery();
        history.push(value.linkTo);
      } else if (
        value &&
        value.subSegment &&
        value.subSegment.length &&
        !isSubListItem
      ) {
        let showItems = [...showListItem];
        let itemIndex = showItems.indexOf(value.id);
        if (itemIndex === -1) {
          if (state.open) {
            showItems.push(value.id);
          } else {
            showListItem = [];
            showItems.push(value.id);
          }
        } else if (open && !value?.children?.includes(showList)) {
          showItems.splice(itemIndex, 1);
        }
        setState({
          ...state,
          open: true,
          showListItem: [...showItems],
        });
      }
    }
  };

  const _getNavigationSubList = list => {
    const uiEle = [];
    const hasRole =
      (props && props.userinfo && props.userinfo.has_role) || false;
    // const toggle = state.showList === list.id && state.open;
    const toggle = state.open && state?.showListItem?.includes(list.id);
    if (props.isCollapsed && (hasRole || list.forUser)) {
      return (
        <li key={`${list.name}-${list.id}`}>
          <div
            className={`${
              state.showList === list.id &&
              (!hasRole || !list.subSegment || list.subSegment.length === 0)
                ? 'dashboard-listitem active active-background'
                : 'dashboard-listitem'
            }`}
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
              _onListClick(list, false);
            }}
          >
            <ContainerIcons
              name={list}
              toggle={state.showList === list.id}
              actionRequired={list.isActionRequired}
            />
          </div>
          <ul className={`ul-list ${toggle ? 'ul-list-show' : 'ul-list-hide'}`}>
            {hasRole &&
              Array.isArray(list.subSegment) &&
              list.subSegment.map(listitem =>
                listitem.forUser || hasRole ? (
                  <li
                    className={
                      state.showListItem === listitem.id
                        ? 'dashboard-listitem active active-background'
                        : 'dashboard-listitem'
                    }
                    key={`${listitem.name}-${listitem.id}`}
                  >
                    <div
                      className="listitem-circle-wrapper"
                      onClick={event => {
                        event.stopPropagation();
                        event.preventDefault();
                        _onListClick(listitem, true);
                      }}
                    >
                      <div
                        className={
                          state.showListItem === listitem.id
                            ? 'listitem-circle active'
                            : 'listitem-circle'
                        }
                      />
                    </div>
                  </li>
                ) : null,
              )}
          </ul>
        </li>
      );
    }
    if (
      list &&
      list.subSegment &&
      list.subSegment.length &&
      (hasRole || list.forUser)
    ) {
      uiEle.push(
        <li
          className={`${'dashboard-listitem'}`}
          key={`${list.name}-${list.id}`}
        >
          <div
            className="list-text padding-r-20"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
              _onListClick(list, false);
            }}
          >
            {list.icon ? (
              <Animation
                play={toggle}
                type={list.icon}
                height={24}
                width={24}
                className="navbar-icon"
                autoPlay={toggle}
              />
            ) : null
            // <Icons active={toggle} size="large" type={list.icon} />
            }
            <span className="visibility left-navbar-title ">{list.name}</span>
            {/* {list.isActionRequired && !toggle && (
              <span className="pending-cue"></span>
            )} */}
            {list.subSegment && (
              <div className={toggle ? 'menu-icon rotate180' : 'menu-icon'}>
                <Icons size="mini" type="dropdown" />
              </div>
            )}
          </div>
          <ul className={`ul-list ${toggle ? 'ul-list-show' : 'ul-list-hide'}`}>
            {Array.isArray(list.subSegment) &&
              list.subSegment.map(listitem =>
                listitem.forUser || hasRole ? (
                  <li key={`${listitem.name}-${listitem.id}`}>
                    <div
                      className={
                        state.showList === listitem.id
                          ? 'listitem-text padding-l-50 active active-background'
                          : 'listitem-text padding-l-50'
                      }
                      onClick={event => {
                        event.stopPropagation();
                        event.preventDefault();
                        _onListClick(listitem, true);
                      }}
                    >
                      {listitem.icon ? (
                        <Animation
                          play={state.showListItem === listitem.id}
                          type={list.icon}
                          height={24}
                          width={24}
                          className="navbar-icon"
                          autoPlay={state.showListItem === listitem.id}
                        />
                      ) : null
                      // <Icons
                      //   active={state.showListItem === listitem.id}
                      //   size="large"
                      //   type={list.icon}
                      // />
                      }
                      <span
                        className={`${
                          state.showListItem === listitem.id ? 'active' : ''
                        } left-navbar-title visibility`}
                      >
                        {listitem.name}
                      </span>
                      {/* <span className="pending-cue"></span> */}
                    </div>
                  </li>
                ) : null,
              )}
          </ul>
        </li>,
      );
    } else if (list.forUser || hasRole) {
      uiEle.push(
        <li
          key={`${list.name}-${list.id}`}
          className={
            state.showList === list.id
              ? 'dashboard-listitem active'
              : 'dashboard-listitem'
          }
        >
          <div
            className="list-text padding-r-20"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
              _onListClick(list, false);
            }}
          >
            {list.icon ? (
              <Animation
                play={state.showList === list.id}
                type={list.icon}
                height={24}
                width={24}
                className="navbar-icon"
                autoPlay={state.showList === list.id}
              />
            ) : null}
            <span
              className={
               `${state.showList === list.id ? 'active' : ''} left-navbar-title visibility`}
            >
              {list.name}
            </span>
          </div>
        </li>,
      );
    }
    return uiEle;
  };

  const _getPrimaryNavigationSubList = list =>
    Array.isArray(list.names) &&
    list.names.map(el => _getNavigationSubList(el));

  const _getDividor = i => <div key={`${i}`} className="divider"></div>;

  const containers = props.containerList.reduce((acc, item, i, self) => {
    acc.push(_getPrimaryNavigationSubList(item));
    if (i !== self.length - 1) {
      acc.push(_getDividor(i));
    }
    return acc;
  }, []);
  return (
    <Scrollbars
      // className="custom-scrollbar"
      renderTrackHorizontal={() => (
        <div
          {...props}
          // className="track-horizontal"
        />
      )}
      renderTrackVertical={() => (
        <div
          {...props}
          // className="track-vertical"
        />
      )}
      renderThumbHorizontal={() => (
        <div
          {...props}
          // className="thumb-horizontal"
        />
      )}
      renderThumbVertical={() => (
        <div
          {...props}
          // className="thumb-vertical"
        />
      )}
      style={{ height: 'calc(100vh - 90px)', top: '45px' }}
    >
      <div
        className="navigation-list"
        // onMouseOver={props.onMouseOver}
        // onMouseLeave={props.onMouseLeave}
      >
        <ul>{containers}</ul>
      </div>
    </Scrollbars>
  );
}

LeftContainerList.propTypes = {
  containerList: PropTypes.array,
  isCollapsed: PropTypes.bool,
  // onMouseOver: PropTypes.func,
  // onMouseLeave: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object,
  userinfo: PropTypes.object,
  historyChange: PropTypes.string,
  // isDashboardView: PropTypes.bool,
};

LeftContainerList.defaultProps = {
  containerList: [],
  isCollapsed: false,
  // isDashboardView: true,
  // onMouseOver: () => {},
  // onMouseLeave: () => {},
  history: {},
  location: {},
  historyChange: PropTypes.string,
};


function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...ExpenseAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftContainerList);